import React from "react";

const FunnelChart = ({ rows = [] }) => {
  if (!rows.length) return null;
  const max = Math.max(1, ...rows.map((r) => Number(r.max ?? r.value ?? 0)));
  return (
    <div className="funnel">
      {rows.map((r, i) => {
        const value = Number(r.value ?? 0);
        const pct = Math.min(100, Math.max(0, (value / max) * 100));
        return (
          <div className="funnel__row" key={r.key ?? r.label ?? i}>
            <div className="funnel__label">{r.label}</div>
            <div className="funnel__track">
              <div className="funnel__fill" style={{ width: `${pct}%` }} />
            </div>
            <div className="funnel__count">{r.display ?? value}</div>
          </div>
        );
      })}
    </div>
  );
};

export default FunnelChart;
